import { ReducerAction } from 'types/reducer';

import { ActiveFilter } from 'proto/Search/ActiveFilter';

export enum SearchFormAction {
    UpdateActiveFilterList = 'UpdateActiveFilterList',
    RemoveActiveFilter = 'RemoveActiveFilter',
    RemoveAllActiveFilter = 'RemoveAllActiveFilter',
}

export type SearchFormReducerAction =
    | ReducerAction<SearchFormAction.UpdateActiveFilterList, ActiveFilter[]>
    | ReducerAction<SearchFormAction.RemoveActiveFilter, string>
    | ReducerAction<SearchFormAction.RemoveAllActiveFilter, void>;

export interface ReducerState {
    activeFilterList: ActiveFilter[];
}
